var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1805 13.9988C16.6163 13.8774 16.1699 14.1394 15.7747 14.3681C15.3699 14.6039 14.6003 15.2283 14.1591 15.0685C11.9004 14.1385 9.77603 12.1615 8.85643 9.89374C8.69435 9.44315 9.3158 8.6686 9.54981 8.25906C9.7769 7.86262 10.0335 7.41203 9.91644 6.84356C9.8107 6.33273 8.44299 4.59239 7.95936 4.11648C7.6404 3.80212 7.31364 3.62922 6.97821 3.60128C5.71711 3.54714 4.30867 5.22984 4.06165 5.6324C3.4428 6.49078 3.44627 7.63296 4.07205 9.01789C5.58017 12.7378 11.2842 18.3518 15.018 19.9166C15.7071 20.2388 16.3372 20.4004 16.9032 20.4004C17.457 20.4004 17.9502 20.2458 18.374 19.9393C18.6939 19.7551 20.4455 18.2767 20.3996 16.9817C20.3719 16.6516 20.1994 16.3216 19.8891 16.002C19.4167 15.5138 17.6876 14.1053 17.1805 13.9988Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceCall);
export default __webpack_public_path__ + "static/media/voiceCall.d9df69ae83a007e86e13c193b538742d.svg";
export { ForwardRef as ReactComponent };